import { type FC } from 'react';
import { Col, Form, Row, Switch } from 'antd';
import { Space, Text } from '@g2u/ui-kit';

import { Condition, type Technician, type WithOptionalDataTest } from 'types';
import { BillingAddressFields, HomeAddressFields, Section } from 'components';
import styles from './address-fields.module.scss';

type Props = {
  title?: string;
  inline?: boolean;
  technician: Technician | null;
} & WithOptionalDataTest;

export const TechnicianAddressFields: FC<Props> = (props) => {
  const { inline, title, technician } = props;
  const form = Form.useFormInstance();
  const sameAddressValue = Form.useWatch('same_address', { form });

  return (
    <Section title={title ?? 'Address'} inline={inline} className={styles.addressFields}>
      <Space.$ direction={Space.Direction.Vertical}>
        <Row>
          <Col>
            <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
              <HomeAddressFields inline form={form} customer={technician} isTechnicianMode={true} />
              <Form.Item
                name="same_address"
                label="Billing Address: "
                required={true}
                initialValue={technician?.same_address === Condition.Yes}
                style={{ margin: 0, padding: 0 }}
              >
                <Space.$>
                  <Switch
                    value={sameAddressValue}
                    onChange={(val) => {
                      form.setFieldValue('same_address', val);
                    }}
                  />
                  <Text.$> Same as above</Text.$>
                </Space.$>
              </Form.Item>
              {!sameAddressValue && (
                <BillingAddressFields inline form={form} customer={technician} isTechnicianMode={true} />
              )}
            </Space.$>
          </Col>
        </Row>
      </Space.$>
    </Section>
  );
};
